const CLARITY_FN_NAME = 'clarity';
let clarityLoaded = false;
const pendingPageViews: string[] = [];

declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

export const initClarity = () => {
  if (clarityLoaded || typeof window === 'undefined') return;

  const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID;
  if (!projectId) {
    return;
  }

  (function (c: any, l: Document, a: string, r: string, i: string, t?: HTMLScriptElement, y?: Node) {
    c[a] =
      c[a] ||
      function (...args: any[]) {
        (c[a].q = c[a].q || []).push(args);
      };
    t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = `https://www.clarity.ms/tag/${i}`;
    y = l.getElementsByTagName(r)[0];
    if (y?.parentNode) {
      y.parentNode.insertBefore(t, y);
    } else {
      l.head.appendChild(t);
    }
  })(window, document, CLARITY_FN_NAME, 'script', projectId);

  clarityLoaded = true;

  const clarity = window[CLARITY_FN_NAME as keyof Window] as ((...args: any[]) => void) | undefined;
  if (clarity) {
    while (pendingPageViews.length) {
      const path = pendingPageViews.shift();
      if (path) {
        clarity('set', 'page', path);
      }
    }
  }
};

export const identifyClarityUser = (userId?: string | null) => {
  if (!userId || typeof window === 'undefined') return;
  const clarity = window[CLARITY_FN_NAME as keyof Window] as ((...args: any[]) => void) | undefined;
  if (!clarity) return;
  try {
    clarity('identify', userId);
  } catch (error) {
    console.warn('Clarity identify failed', error);
  }
};

export const trackClarityEvent = (name: string, data?: Record<string, any>) => {
  if (typeof window === 'undefined') return;
  const clarity = window[CLARITY_FN_NAME as keyof Window] as ((...args: any[]) => void) | undefined;
  if (!clarity) return;
  try {
    if (data) {
      clarity('event', name, data);
    } else {
      clarity('event', name);
    }
  } catch (error) {
    console.warn('Clarity event failed', error);
  }
};

export const trackClarityPage = (path: string) => {
  if (typeof window === 'undefined') return;
  const clarity = window[CLARITY_FN_NAME as keyof Window] as ((...args: any[]) => void) | undefined;
  if (clarity) {
    clarity('set', 'page', path);
    return;
  }
  pendingPageViews.push(path);
};
